import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type BillingUpgradePageStore } from 'pages/settings/pages/billing/pages/upgrade/store/upgradePageStore'

export const BillingUpgradePageContext = createContext<BillingUpgradePageStore | null>(null)

export const useBillingUpgradePageContext = () => {
  const context = useContext(BillingUpgradePageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with BillingUpgradePageContext')

  return context
}

type IProviderBillingUpgradePageProps = {
  value: BillingUpgradePageStore
  children: ReactNode
}

export const ProviderBillingUpgradePage: FC<IProviderBillingUpgradePageProps> = ({
  value,
  children,
}) => {
  return (
    <BillingUpgradePageContext.Provider value={value}>
      {children}
    </BillingUpgradePageContext.Provider>
  )
}
